const eventEditorQueryKeys = {
  all: ['dashboard', 'eventEditor'] as const,
  event: (eventId: number) => [...eventEditorQueryKeys.all, eventId] as const,
  eventSessions: (eventId: number) => [...eventEditorQueryKeys.event(eventId), 'sessions'] as const,
  eventGuestStats: (eventId: number) =>
    [...eventEditorQueryKeys.event(eventId), 'guestStats'] as const,
  eventGuestsList: (
    eventId: number,
    filters: {
      currentPage?: number;
      pageSize?: number;
      statuses?: string[];
      departments?: string[];
      attendanceFilters?: string[];
      searchText?: string;
      sortBy?: string;
      sortOrder?: string;
    }
  ) => [...eventEditorQueryKeys.event(eventId), 'guestsList', filters] as const,
  eventCommunication: (eventId: number) =>
    [...eventEditorQueryKeys.event(eventId), 'communication'] as const,
  eventFeedback: (eventId: number) =>
    [...eventEditorQueryKeys.event(eventId), 'eventFeedback'] as const,
  eventRegistration: (eventId: number) =>
    [...eventEditorQueryKeys.event(eventId), 'eventRegistration'] as const,
  eventDistrolistInvites: (eventId: number) =>
    [...eventEditorQueryKeys.event(eventId), 'distrolistInvites'] as const,
  eventCommunityInvites: (eventId: number) =>
    [...eventEditorQueryKeys.event(eventId), 'communityInvites'] as const,
  eventGuestDepartments: (eventId: number) =>
    [...eventEditorQueryKeys.event(eventId), 'guestDepartments'] as const,
  eventInviteeCount: (
    eventId: number,
    userIds: number[],
    distrolistIds: number[],
    communityIds: number[]
  ) =>
    [
      ...eventEditorQueryKeys.event(eventId),
      'inviteeCount',
      { userIds, distrolistIds, communityIds }
    ] as const,
  eventInvitableUsers: (eventId: number, searchText: string) =>
    [...eventEditorQueryKeys.event(eventId), 'invitableUsers', searchText] as const,
  eventInvitableCommunities: (eventId: number, searchText: string) =>
    [...eventEditorQueryKeys.event(eventId), 'invitableCommunities', searchText] as const,
  companyDistrolists: (searchText: string) =>
    [...eventEditorQueryKeys.all, 'distrolists', searchText] as const,
  eventInvitationJobStatus: (eventId: number) =>
    [...eventEditorQueryKeys.event(eventId), 'invitationJobStatus'] as const,

  // Questionnaire responses
  eventQuestionnaires: ['dashboard', 'eventEditor', 'questionnaires'] as const,
  eventAggregatedQuestionnaireResponses: (questionId: number) =>
    [...eventEditorQueryKeys.eventQuestionnaires, questionId, 'aggregatedResponses'] as const,
  eventPaginatedQuestionnaireResponses: (questionId: number, currentPage: number) =>
    [
      ...eventEditorQueryKeys.eventQuestionnaires,
      questionId,
      'paginatedResponses',
      currentPage
    ] as const
};

export { eventEditorQueryKeys };
